import React, { useEffect, useState } from "react"
import _ from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { getReportsSelector } from '../../../../../../../../redux/reducers/reducerSlices/ReportsReducerSlice';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import DrilldownTableBody from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableBody';
import { AppConstant } from "../../../../../../../Assests/AppConstant";
import { numberWithCommas } from '../../../../../../../Assests/Utility'


const TruckUnloadSummaryList = (props) => {

    const dispatch = useDispatch();
    const { themeSelected, isLoading } = props;
    const reportsSelector = useSelector(getReportsSelector);
    const { truckUnloadSummary, initateLoading } = reportsSelector;
    const [truckUnloadSummaryArr, setTruckUnloadSUmmryArr] = useState([]);

    const unloadSummaryTitleDD = [
        { id: 'Dock', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.dockNameStr },
        { id: 'TrucksUnloaded', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.trucksUnloadedStr },
        { id: 'TrucksUnloadedPct', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.truckUnloadedPctVendorStr },
        { id: 'EndPallets', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.endPallets },
        { id: 'PalletsperHour', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.palletsPerHour },
        { id: 'AvgUnloadTime', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgUnloadTime },
        { id: 'LoadswithUnloadDelay', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.loadsWithUnloadsDelay },
        { id: 'AvgCheckoutTime', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgCheckOutTime },
        { id: 'LoadswithCheckOutDelay', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.loadsWithCheckOutDelay },
        { id: 'LoadsArrivedLate', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.loadsArrivedLate },
        { id: 'AvgDoorAssigntoUnloadFinish', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgDoorAssignedToUnloadFinish },
        { id: 'AvgDoorAssigntoBillin', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgDoorAssignedToBillsIn },
        { id: 'AvgBillintoLumpStart', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgBillsInToUnloadStart },
        { id: 'AvgAppttoBillout', name: AppConstant.reports.truckUnloadSummaryReport.tableHeaders.avgApptToBillsOut },
    ]


    useEffect(() => {
        if (truckUnloadSummary && truckUnloadSummary.length) {
            setTruckUnloadSUmmryArr(truckUnloadSummary);
            setTimeout(() => {
                dispatch({ type: sagaActions.INTIATE_LOADER_REPORTS, payload: false })
            }, 500)
        }
    }, [truckUnloadSummary])

    const formatListDataDrillDown = (data) => {
        return data.map((el, index) => {
            return {
                id: index,
                0: el.Dock ? el.Dock : '-',
                1: el.TrucksUnloaded ? numberWithCommas(el.TrucksUnloaded) : '-',
                2: el.TrucksUnloadedPct ? numberWithCommas(el.TrucksUnloadedPct) : '-',
                3: el.EndPallets ? numberWithCommas(el.EndPallets) : '-',
                4: el.PalletsperHour ? numberWithCommas(el.PalletsperHour) : '-',
                5: el.AvgUnloadTime ? numberWithCommas(el.AvgUnloadTime) : '-',
                6: el.LoadswithUnloadDelay ? numberWithCommas(el.LoadswithUnloadDelay) : '-',
                7: el.AvgCheckoutTime ? numberWithCommas(el.AvgCheckoutTime) : '-',
                8: el.LoadswithCheckOutDelay ? numberWithCommas(el.LoadswithCheckOutDelay) : '-',
                9: el.LoadsArrivedLate ? numberWithCommas(el.LoadsArrivedLate) : '-',
                10: el.AvgDoorAssigntoUnloadFinish ? numberWithCommas(el.AvgDoorAssigntoUnloadFinish) : '-',
                11: el.AvgDoorAssigntoBillin ? numberWithCommas(el.AvgDoorAssigntoBillin) : '-',
                12: el.AvgBillintoLumpStart ? numberWithCommas(el.AvgBillintoLumpStart) : '-',
                13: el.AvgAppttoBillout ? numberWithCommas(el.AvgAppttoBillout) : '-',
            }
        })
    }

    return (
        <div className="mx-2 py-2">

            <table className="m-0 p-0">
                {/* <table className="m-0 p-0 table table-responsive table-hover"> */}
                <thead>
                    <tr>
                        {/* <tr className={`text-center align-middle ${themeSelected} truck-list-title`}> */}
                        {
                            unloadSummaryTitleDD.map((el) => {
                                return (
                                    // <th colSpan={el.colSpan} scope="col" className={`col px-0 ${themeSelected} title-text-container `} id={el.id} key={el.id}>
                                    <th colSpan={el.colSpan} scope="col" className={`col px-0 ${themeSelected} truckUnloadSummaryHeading text-center border border-1`} id={el.id} key={el.id}>
                                        <span className='text-center'>{el.name}</span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <DrilldownTableBody
                    themeSelected={themeSelected}
                    data={truckUnloadSummaryArr && truckUnloadSummaryArr && formatListDataDrillDown(truckUnloadSummaryArr)}
                    showCollapse={false}
                    showInput={false}
                    showSort={false}
                    initiateDrillDownReport={initateLoading}
                    loaderArray={17}
                    sortKey={true}
                    showUTCTime={true}
                />
            </table>
        </div>
    )
}

export default TruckUnloadSummaryList